import { useState } from 'react';

export default function Schedule() {
  const [selectedMonth, setSelectedMonth] = useState('2025-01');

  const schedules = [
    {
      date: '2025-01-15',
      day: '水',
      time: '19:00',
      venue: 'TOKYO LIVE HOUSE SHIBUYA',
      artist: '山田 太郎',
      title: 'New Year Rock Night',
      genre: 'ロック',
      price: '¥3,500'
    },
    {
      date: '2025-01-18',
      day: '土',
      time: '18:30',
      venue: 'SHINJUKU MUSIC CLUB',
      artist: '佐藤 花子',
      title: 'Jazz Evening Special',
      genre: 'ジャズ',
      price: '¥4,000'
    },
    {
      date: '2025-01-22',
      day: '水',
      time: '19:30',
      venue: 'ROPPONGI SOUND STAGE',
      artist: 'THE TOKYO BEATS',
      title: 'Pop Music Festival',
      genre: 'ポップ',
      price: '¥3,800'
    },
    {
      date: '2025-01-25',
      day: '土',
      time: '18:00',
      venue: 'IKEBUKURO LIVE SPOT',
      artist: '鈴木 健一',
      title: 'Acoustic Folk Night',
      genre: 'フォーク',
      price: '¥3,000'
    },
    {
      date: '2025-01-28',
      day: '火',
      time: '20:00',
      venue: 'HARAJUKU MUSIC BOX',
      artist: 'DJ TOKYO NIGHT',
      title: 'Electronic Dance Party',
      genre: 'エレクトロニック',
      price: '¥3,500'
    },
    {
      date: '2025-02-01',
      day: '土',
      time: '19:00',
      venue: 'AKIHABARA SOUND HALL',
      artist: '田中 美咲',
      title: 'Singer-Songwriter Live',
      genre: 'シンガーソングライター',
      price: '¥3,200'
    },
    {
      date: '2025-02-05',
      day: '水',
      time: '19:30',
      venue: 'TOKYO LIVE HOUSE SHIBUYA',
      artist: 'URBAN GROOVE',
      title: 'R&B Soul Night',
      genre: 'R&B/ソウル',
      price: '¥3,800'
    },
    {
      date: '2025-02-08',
      day: '土',
      time: '18:30',
      venue: 'SHINJUKU MUSIC CLUB',
      artist: '伊藤 誠',
      title: 'Blues Guitar Session',
      genre: 'ブルース',
      price: '¥4,200'
    },
    {
      date: '2025-02-12',
      day: '水',
      time: '19:00',
      venue: 'ROPPONGI SOUND STAGE',
      artist: '山田 太郎',
      title: 'Rock Revolution',
      genre: 'ロック',
      price: '¥3,500'
    },
    {
      date: '2025-02-15',
      day: '土',
      time: '18:00',
      venue: 'IKEBUKURO LIVE SPOT',
      artist: '佐藤 花子',
      title: 'Valentine Jazz Concert',
      genre: 'ジャズ',
      price: '¥4,500'
    },
    {
      date: '2025-02-19',
      day: '水',
      time: '19:30',
      venue: 'HARAJUKU MUSIC BOX',
      artist: 'THE TOKYO BEATS',
      title: 'Pop Hits Live',
      genre: 'ポップ',
      price: '¥3,800'
    },
    {
      date: '2025-02-22',
      day: '土',
      time: '18:30',
      venue: 'AKIHABARA SOUND HALL',
      artist: '鈴木 健一',
      title: 'Folk Music Journey',
      genre: 'フォーク',
      price: '¥3,000'
    }
  ];

  const filteredSchedules = schedules.filter(schedule => 
    schedule.date.startsWith(selectedMonth)
  );

  return (
    <section id="schedule" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">ライブスケジュール</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            東京クラブ参加会場で開催される最新のライブスケジュールをご確認いただけます。
            お気に入りのアーティストのライブをお見逃しなく。
          </p>
        </div>

        <div className="mb-8 flex justify-center">
          <div className="inline-flex bg-gray-100 rounded-lg p-1">
            <button
              onClick={() => setSelectedMonth('2025-01')}
              className={`px-6 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                selectedMonth === '2025-01' 
                  ? 'bg-gray-900 text-white' 
                  : 'text-gray-700 hover:text-gray-900'
              }`}
            >
              2025年1月
            </button>
            <button
              onClick={() => setSelectedMonth('2025-02')}
              className={`px-6 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                selectedMonth === '2025-02' 
                  ? 'bg-gray-900 text-white' 
                  : 'text-gray-700 hover:text-gray-900'
              }`}
            >
              2025年2月
            </button>
          </div>
        </div>

        <div className="space-y-4">
          {filteredSchedules.map((schedule, index) => (
            <div key={index} className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow">
              <div className="flex flex-col md:flex-row md:items-center gap-6">
                <div className="flex-shrink-0 text-center">
                  <div className="bg-gray-900 text-white rounded-lg p-4 w-20">
                    <div className="text-2xl font-bold">{schedule.date.split('-')[2]}</div>
                    <div className="text-xs mt-1">{schedule.day}曜日</div>
                  </div>
                </div>
                
                <div className="flex-grow">
                  <div className="flex flex-wrap items-center gap-3 mb-2">
                    <h3 className="text-xl font-bold text-gray-900">{schedule.title}</h3>
                    <span className="px-3 py-1 bg-gray-100 text-gray-700 text-xs rounded-full whitespace-nowrap">
                      {schedule.genre}
                    </span>
                  </div>
                  <div className="space-y-1 text-sm text-gray-600">
                    <div className="flex items-center gap-2">
                      <i className="ri-user-line"></i>
                      <span>{schedule.artist}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <i className="ri-map-pin-line"></i>
                      <span>{schedule.venue}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <i className="ri-time-line"></i>
                      <span>開演 {schedule.time}</span>
                    </div>
                  </div>
                </div>

                <div className="flex-shrink-0 text-right">
                  <div className="text-2xl font-bold text-gray-900 mb-2">{schedule.price}</div>
                  <button className="px-6 py-2 bg-gray-900 text-white rounded-md text-sm font-medium hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap">
                    詳細を見る
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}